import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FaTrash,FaPlus } from 'react-icons/fa';
import { Search } from 'lucide-react';
import classes from "./Remitance.module.css"
import { toast, ToastContainer } from 'react-toastify';
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form,Row, Col } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from 'sweetalert2';







const Remitance = () => {
  const [selectedOption, setSelectedOption] = useState(null);
   const [allAccounts, setAllAccounts] = useState([]);
   const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
     const [selectedBank, setSelectedBank] = useState('');
       const [income, setIncome] = useState([]);
   const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
    const [error, setError] = useState(null);
   const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
   const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState(null);
  const [debit1, setDebit1] = useState([]);
      const [incomeLoading, setIncomeLoading] = useState(false);
  const [foundRemitance,setFoundRemitance] = useState([]);
  const [totalCredit, setTotalCredit] = useState(0);
  const [incomeAmount, setIncomeAmount] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [ledgTableData, setLedgTableData] = useState([]);
 const [load, setLoad] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [formData, setFormData] = useState([]);
  //      const [formData, setFormData] = useState(() => {
  //     return (
  //         foundRemitance?.items?.map((item, index) => ({
  //             sn: index + 1,
  //             accountName: item.item?.id,
  //             accountCode: item.item?.gl_code,
  //             amount: item.amount,
  //         })) || []
  //     );
  // });

   const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
         const current = await localStorage.getItem('currentMonth');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
        if (current !== null) {
              console.log(current);
              const date = new Date(current);
            
              const startOfDateRange = new Date(1900, 0, 1);
           
              const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            
              // Format date function as 'YYYY-MM-DD'
              const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); 
                const day = String(date.getDate()).padStart(2, '0');     
                return `${year}-${month}-${day}`;
              };
            
              setMinDate(formatDate(startOfDateRange));
              setMaxDate(formatDate(endOfDateRange));
            
              console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
            }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

   const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => { 
    setShow(false);
    setSelectedDebitAccount('');
    setIncomeAmount('');
    setIncomeAmount('');
    setTotalCredit('');
    setSelectedCustomer('');
          setDescription('');
          setSelectedDate("");
          setSelectedDebitAccount('');
          setIncomeAmount('');
          setIncomeAmount('');
          setTotalCredit('');
          setFormData([]);
    };

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
        const results = response.data?.data?.data;
        const resultx = response.data?.data?.total;
        setTotalEntries(resultx);
        setTableData(results);
        console.log(results, "From Remittane")
        const total = response.data?.data?.last_page || 1;
        setTotalPages(total);
      
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response?.data && error.response?.data.message) {
              if (typeof error.response?.data.message === 'string') {
                  errorMessage = error.response?.data.message;
              } else if (Array.isArray(error.response?.data.message)) {
                  errorMessage = error.response?.data.message.join('; ');
              } else if (typeof error.response?.data.message === 'object') {
                console.log(errorMessage);
                setError(errorMessage)
              }
          }
            setTableData([]);
        }
    } finally {
        setBenLoading(false);
    }
    
  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

   const fetchAccounts = async () => {
        setFetchingLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/search_monthly_remittance`, {
                params: {
                    credit_gl_code: selectedBank,
                    start_date: selectedDate,
                    end_date: selectedEndDate
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${bearer}`
                }
            });

        const results = response.data?.data?.data;
        const resultx = response.data?.data?.total;
        setTotalEntries(resultx);
        setTableData(results);
        console.log(results, "From Remittane")
        const total = response.data?.data?.last_page || 1;
        setTotalPages(total);
            // const resultsss = response.data?.data?.receipt;
            const resultsss = response.data?.data?.receipt;
            setAccounts(resultsss);

            const resultssx = response.data?.data?.input;
            setInputss(resultssx);

            console.log(resultsss);

            if (resultsss?.length > 0) {
                navigate('/cash_management/print_income', {
                    state: {
                        document: resultsss,
                        inputs: resultssx
                    }
                });
            } else {
                // toast.error('No data for the selected account');
            }
        } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
            }
            // toast.error(errorMessage);
            console.log(errorMessage);
        } finally {
            setFetchingLoading(false);
        }
    };


      const fetchAccountss = async () => {
        console.log(headers)
        setLoadings(true);

        try {
            const response = await axios.get(`${BASE_URL}/account`, { headers });

            const CustomOption = (props) => {
              const { data, innerRef, innerProps } = props;
              return (
                <div ref={innerRef} {...innerProps}>
                  <span style={{ color: 'blue' }}>{data?.gl_code}</span>
                  {' - '}
                  <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
                </div>
              );
            };

            const allAccts = response.data?.data;
            const opt1 = allAccts.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
            }));
            setAllAccounts(opt1);

            //   console.log(allAccts, "All Accounts");
        } catch (error) {
            const errorStatus = error.response?.data.message;
            console.error(errorStatus);
        } finally {
            setLoadings(false);
        }
    };

 useEffect(() => {
    if (bearer) {
        fetchAccountss();
    }
}, [bearer]);


function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };
  
  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

const formattedTotalEntries = totalEntries.toLocaleString();

 const fetchStat = async () => {
    setStatLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
        const stas = response.data?.data;
       
        setStat(stas);
     
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                console.log(errorMessage);
              }
          }
            setStat([]);
        }
    } finally {
        setStatLoading(false);
    }
};

useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  
    const fetchCustomers = async () => {
      setLoading(true);
  
  
      try {
        const response = await axios.get(
          `${BASE_URL}/customer/no-pagination`,
          {
  
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
        const custome = response.data?.data;
        const customs = custome.map(item => ({
          label: item.name,
          value: item.id,
          balance: item.balance
        }));
        setCustomerList(customs);
        if (foundRemitance && foundRemitance.id) {
          const selectedCust = customs.find(item => item.value === foundRemitance.customer.id);
         console.log(selectedCust);
          setSelectedCustomer(selectedCust);
        }
      
        // setAddress(custome);
  
        console.log(response, "itss");
      } catch (error) {
        const errorStatus = error.response.data.message;
        console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (bearer) {
        fetchCustomers();
      }
    }, [bearer,foundRemitance]);

  const formatStat = (value) => {
  if (value == null) return "";

  if (value >= 1000 && value < 1000000) {
    const rounded = value / 1000;
    // If divisible by 1000 exactly, no decimals (30k)
    if (value % 1000 === 0) {
      return `${rounded}k`;
    }
    // Else show 2 decimals (30.01k)
    return `${rounded.toFixed(2)}k`;
  }

  if (value >= 1000000) {
    const rounded = value / 1000000;
    if (value % 1000000 === 0) {
      return `${rounded}M`;
    }
    return `${rounded.toFixed(2)}M`;
  }

  // smaller than 1000 → just locale string with commas
  return value.toLocaleString("en-US");
};

const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
 const handleDateChange1 = (event) => {
        setSelectedEndDate(event.target.value);
    };

 const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    const createIncome = async () => {
    setIncomeLoading(true);

    try {
        const accountNames = formData.map((row) => row.accountName).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((amount) => amount !== undefined);
        const payload = {
          id: foundRemitance?.id,
            account_id: accountNames,
            debit_gl: selectedDebitAccount?.value || '',
            description: description,
            customer_id: selectedCustomer?.value || '',
            // payment_mode: selectedPayment,
            amount: amounts,
            total_credit: totalCredit,
            total_debit: incomeAmount,
            // teller_no: teller,
            // particulars: receive,
            // currency: selectedCurrency,
            transaction_date: selectedDate,
            // bank_id: selectedBanks
        };

        console.log("Payload:", payload);

        const response = await axios.post(`${BASE_URL}/update-remittance`, payload, { headers });

        console.log(response.data, "Response Data");
        // navigate(-1);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });
handleCloseModal();
handleCustomers();
        // toast.success(response.data.message);
    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
              // toast.error(errorMessage);
            }
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: JSON.stringify(error.response.data.message),
            });
        }
    } finally {
        setIncomeLoading(false);
    }
};

const [incomeLoadingg, setIncomeLoadingg] = useState(false);
    const postIncome = async () => {
    setIncomeLoadingg(true);

    try {
        const accountNames = formData.map((row) => row.accountName).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((amount) => amount !== undefined);
        const payload = {
          
            account_id: accountNames,
            debit_gl: selectedDebitAccount || '',
            description: description,
            customer_id: selectedCustomer || '',
            // payment_mode: selectedPayment,
            amount: amounts,
            total_credit: totalCredit,
            total_debit: incomeAmount,
            // teller_no: teller,
            // particulars: receive,
            // currency: selectedCurrency,
            transaction_date: selectedDate,
            // bank_id: selectedBanks
        };

        console.log("Payload:", payload);

        const response = await axios.post(`${BASE_URL}/post-new-remittance`, payload, { headers });

        console.log(response.data, "Response Data");
        // navigate(-1);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });
          handleClose();
          handleCustomers();
          setSelectedCustomer('');
          setDescription('');
          setSelectedDate("");
          setSelectedDebitAccount('');
          setIncomeAmount('');
          setIncomeAmount('');
          setTotalCredit('');
          setFormData([]);
        // toast.success(response.data.message);
    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
              // toast.error(errorMessage);
            }
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: JSON.stringify(error.response.data.message),
            });
        }
    } finally {
        setIncomeLoadingg(false);
    }
};

   const fetchReceipt = async () => {
        setLoad(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
            const results = response.data?.data?.data;
            const resultx = response.data?.data?.total;
            setLedgTableData(results);
            const total = response.data?.data?.last_page || 1;
            setTotalPages(total);
            console.log("fetched Receipts:", results);
            // toast.success(response.data.message);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigate('/login');
            } else {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                    } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                    } else if (typeof error.response.data.message === 'object') {
                        toast.error(errorMessage)
                        console.log(errorMessage);
                    }
                }
                setTableData([]);
            }
        } finally {
            setLoad(false);
        }
    };



    useEffect(() => {
        if (bearer) {
            fetchReceipt();

        }
    }, [bearer, currentPage]);
    

     const calculateTotalCredit = () => {
        const total = formData.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
        const formattedTotal = total.toFixed(2);
        setTotalCredit(formattedTotal);
    };


    useEffect(() => {

        calculateTotalCredit();
    }, [formData]);


 const handleBank = (selectedOption) => {
        setSelectedBank(selectedOption.value);
    };
  const handleValueChange1 = (value, index) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            amount: value,
        };
        setFormData(updatedFormData);
        calculateTotalCredit(); // Recalculate total credit whenever table amounts change
    };
    const goBack = () => {
        navigate(-1);
    }


     const handleAccountChange = (index, event) => {
        const selectedAccount = event.target.value;
        const intselectedId = parseInt(selectedAccount);
        const selectedGlCode = income.find((item) => item.id === intselectedId)?.gl_code || '';

        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            accountName: selectedAccount,
            accountCode: selectedGlCode,
        };

        setFormData(updatedFormData);
    };

    const handleCreate = () => {

    }
       const addRow = () => {
        const newRow = {
            sn: formData.length + 1,
            accountName: '',
            accountCode: '',
            amount: ''
        };
        setFormData([...formData, newRow]);
        // setSelectedPayment('');
    };

    const deleteRow = (index) => {
        const updatedData = formData.filter((_, i) => i !== index);
        setFormData(updatedData);
    };

     const handleValueChange = (value) => {
        setIncomeAmount(value);
    };

   useEffect(() => {
  if (foundRemitance?.items) {
    const mapped = foundRemitance.items.map((item, index) => ({
      sn: index + 1,
      accountName: item.item?.id,
      accountCode: item.item?.gl_code,
      amount: item.amount,
    }));
    setFormData(mapped);
  }
  if (foundRemitance?.transaction_date) {
    setSelectedDate(foundRemitance.transaction_date);
  }
   if (foundRemitance?.description) {
    setDescription(foundRemitance.description);
  }
   if (foundRemitance?.amount) {
    setIncomeAmount(foundRemitance.amount);
  }

  if (foundRemitance?.debit_account) {
    setSelectedDebitAccount(foundRemitance.debit_account.id);
  }
}, [foundRemitance]);

const handlePrint = (id) => {
  handleOpenModal();
  const selectedLedger = ledgTableData.find(item => item.id === id);
  setFoundRemitance(selectedLedger);
  console.log(selectedLedger); // use this instead of FormData
};

 const handleTrashClick = async (id) => {
      const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You are about to delete this remittance.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel',
      });
  
      if (!confirmed.isConfirmed) {
        return; // User canceled, do nothing
      }
  
      try {
        const response = await axios.get(`${BASE_URL}/delete-remittance?id=${id}`, { headers });
        fetchReceipt();
        Swal.fire({
          icon: 'success',
          title: 'Successful',
          text: response.data.message,
        });
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
          });
          console.log(errorMessage);
        }
      }
    };

 const fetchDebit1 = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/get-loans-receivables`,{headers});
        
          const debt1 = response.data?.data;
          const oopt1 = debt1.map((item) => ({
            label: item.gl_name,
            value: item.id,
         
            
          }));
          setDebit1(oopt1);

        if (foundRemitance && foundRemitance.account?.debit) {
          const slctedDebit = oopt1.find(item => item.value === foundRemitance.account?.debit.id);
          console.log(slctedDebit);
          setSelectedDebitAccount(slctedDebit);
        }
    
      
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

        useEffect(() => {
        if (bearer) {
           fetchDebit1();
        }
    }, [bearer,foundRemitance]);
 const fetchIncome = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/get-account-by-class-id?class_id=${4}`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const inc = response.data?.data;

          setIncome(inc);
    
        //   console.log(debitAcc, "Debit Accounts");
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
        fetchIncome();
    }, [bearer]);

    const handleCustomerChange = (selectedOption) => {
      setSelectedCustomer(selectedOption.value);
    };

     const handleAssetChange = (selectedOption) => {
        setSelectedDebitAccount(selectedOption.value);
    };
    
  return (
     <div className={classes.topTopT} >
 <Modal
  show={showModal}
  onHide={handleCloseModal}
  size="lg"
  centered
  backdrop="static"
  scrollable
>
  {/* Header */}
  <Modal.Header closeButton>
    <Modal.Title className="h5">Update Remittance</Modal.Title>
  </Modal.Header>

  {/* Body */}
  <Modal.Body>
    <Form style={{ paddingLeft: "25px", paddingRight: "25px" }}>
      {/* Row 1: Customer + Transaction Date */}
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={4} style={{ textAlign: "left" }}>
              Customer:
            </Form.Label>
            <Col md={8}>
              <Select
                value={selectedCustomer}
                isLoading={loading}
                options={customerList}
                placeholder="Select Customer"
                onChange={setSelectedCustomer}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </Col>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label
              column
              md={5}
              style={{ textAlign: "right", whiteSpace: "nowrap" }}
            >
              Transaction Date:
            </Form.Label>
            <Col md={7}>
              <Form.Control
                type="date"
                value={selectedDate}
                onChange={handleDateChange}
                min={minDate}
                max={maxDate}
              />
            </Col>
          </Form.Group>
        </Col>
      </Row>

      {/* Description */}
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={2} style={{ textAlign: "left" }}>
              Description:
            </Form.Label>
            <Col md={10}>
              <Form.Control
                as="textarea"
                rows={2}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Col>
          </Form.Group>
        </Col>
      </Row>

      {/* Debit Account + Amount */}
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label
              column
              md={4}
              style={{ textAlign: "left", whiteSpace: "nowrap" }}
            >
              Debit Account:
            </Form.Label>
            <Col md={8}>
              <Select
                value={selectedDebitAccount}
                isLoading={loading}
                onChange={setSelectedDebitAccount}
                options={debit1}
                placeholder="Select Debit GL"
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </Col>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={4} style={{ textAlign: "right" }}>
              Amount:
            </Form.Label>
            <Col md={8}>
              <CurrencyInput
                name="amount"
                decimalsLimit={2}
                className="form-control"
                value={incomeAmount}
                onValueChange={handleValueChange}
                style={{ textAlign: "right" }}
              />
            </Col>
          </Form.Group>
        </Col>
      </Row>

      {/* Table */}
      <div
        className="table-responsive mb-3"
        style={{ maxHeight: "250px", overflowY: "auto" }}
      >
        <table className="table table-bordered table-hover table-sm align-middle mb-0 text-center">
          <thead className="table-light small">
            <tr>
              <th className="py-1 px-2">#</th>
              <th className="py-1 px-2" style={{ width: "40%", fontWeight: 400 }}>
                Account Name
              </th>
              <th className="py-1 px-2">Account Code</th>
              <th className="py-1 px-2">Amount</th>
              <th className="py-1 px-2">
                <Button variant="primary" size="sm" onClick={addRow}>
                  <FaPlus size={12} color="white" />
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {formData?.map((row, index) => (
              <tr key={index}>
                <td className="align-middle">{row.sn}</td>
                <td className="align-middle">
                  <Form.Select
                    value={row.accountName}
                    onChange={(e) => handleAccountChange(index, e)}
                    size="sm"
                  >
                    <option value="">Select Account</option>
                    {income.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.gl_name}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <td className="align-middle">
                  <Form.Control
                    type="text"
                    value={row.accountCode}
                    readOnly
                    disabled
                    size="sm"
                  />
                </td>
                <td className="align-middle">
                  <CurrencyInput
                    name={`rowAmount-${index}`}
                    value={row.amount}
                    className="form-control form-control-sm text-end"
                    onValueChange={(value) => handleValueChange1(value, index)}
                  />
                </td>
                <td className="align-middle">
                  <Button variant="danger" size="sm" onClick={() => deleteRow(index)}>
                    <FaTrash size={12} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <Row className="mt-3 justify-content-end">
        <Col md={6}>
          <Row className="g-3">
            <Col>
              <Form.Group>
                <Form.Label>Total Debit</Form.Label>
                <CurrencyInput
                  name="totalDebit"
                  decimalsLimit={2}
                  className="form-control"
                  value={incomeAmount}
                  disabled
                  style={{ textAlign: "right" }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Total Credit</Form.Label>
                <CurrencyInput
                  name="totalCredit"
                  decimalsLimit={2}
                  className="form-control"
                  value={totalCredit}
                  disabled
                  style={{ textAlign: "right" }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  </Modal.Body>

  {/* Footer */}
  <Modal.Footer style={{ paddingLeft: "25px", paddingRight: "25px" }}>
    <Button variant="light" onClick={handleCloseModal}>
      Cancel
    </Button>
    <Button
      variant="success"
      disabled={parseFloat(incomeAmount) !== parseFloat(totalCredit)}
      onClick={createIncome}
      className={classes.btnss}
    >
      {incomeLoading ? (
        <>
          <Spinner size="sm" />
          <span className="ms-2">Processing...</span>
        </>
      ) : (
        "Update Remittance"
      )}
    </Button>
  </Modal.Footer>
</Modal>



<Modal
  show={show}
  onHide={handleClose}
  size="lg"
  centered
  backdrop="static"
  scrollable
>
  {/* Header */}
  <Modal.Header closeButton>
    <Modal.Title className="h5">Add New Remittance</Modal.Title>
  </Modal.Header>

  {/* Body */}
  <Modal.Body>
    <Form style={{ paddingLeft: "25px", paddingRight: "25px" }}>
      {/* Row 1: Customer + Transaction Date */}
     <Row className="mb-3">
        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={4} style={{ textAlign: "left" }}>
              Customer:
            </Form.Label>
            <Col md={8}>
              <Select
                isLoading={loading}
                options={customerList}
                placeholder="Select Customer"
                onChange={handleCustomerChange}
                // value={selectedCustomer}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </Col>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={5} style={{ textAlign: "right",whiteSpace:'nowrap' }}>
              Transaction Date:
            </Form.Label>
            <Col md={7}>
              <Form.Control
                type="date"
                value={selectedDate}
                onChange={handleDateChange}
                min={minDate}
                max={maxDate}
              />
            </Col>
          </Form.Group>
        </Col>
      </Row>

      {/* Row 2: Description */}
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={2} style={{ textAlign: "left" }}>
              Description:
            </Form.Label>
            <Col md={10}>
              <Form.Control
                as="textarea"
                rows={2}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                name="description"
              />
            </Col>
          </Form.Group>
        </Col>
      </Row>

      {/* Row 3: Debit Account + Amount */}
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={4} style={{ textAlign: "left",whiteSpace:"nowrap" }}>
              Debit Account:
            </Form.Label>
            <Col md={8}>
              <Select
                isLoading={loading}
                options={debit1}
                placeholder="Select Debit GL"
                onChange={handleAssetChange}
                // value={selectedDebitAccount}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </Col>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column md={4} style={{ textAlign: "right" }}>
              Amount:
            </Form.Label>
            <Col md={8}>
              <CurrencyInput
                name="amount"
                decimalsLimit={2}
                className="form-control"
                value={incomeAmount}
                onValueChange={handleValueChange}
                style={{ textAlign: "right" }}
              />
            </Col>
          </Form.Group>
        </Col>
      </Row>

      {/* Table */}
      <div
        className="table-responsive"
        style={{ maxHeight: "250px", overflowY: "auto" }}
      >
        <table className="table table-bordered table-hover table-sm align-middle mb-0 text-center">
          <thead className="table-light small">
            <tr>
              <th className="py-1 px-2">#</th>
              <th className="py-1 px-2" style={{ width: "40%" }}>
                Account Name
              </th>
              <th className="py-1 px-2">Account Code</th>
              <th className="py-1 px-2">Amount</th>
              <th className="py-1 px-2">
                <Button variant="primary" size="sm" onClick={addRow}>
                  <FaPlus size={12} color="white" />
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {formData?.map((row, index) => (
              <tr key={index}>
                <td className="align-middle">{row.sn}</td>
                <td className="align-middle">
                  <Form.Select
                    value={row.accountName}
                    onChange={(e) => handleAccountChange(index, e)}
                    size="sm"
                  >
                    <option value="">Select Account</option>
                    {income.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.gl_name}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <td className="align-middle">
                  <Form.Control
                    type="text"
                    value={row.accountCode}
                    readOnly
                    disabled
                    size="sm"
                  />
                </td>
                <td className="align-middle">
                  <CurrencyInput
                    name={`rowAmount-${index}`}
                    value={row.amount}
                    className="form-control form-control-sm text-end"
                    onValueChange={(value) => handleValueChange1(value, index)}
                  />
                </td>
                <td className="align-middle">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => deleteRow(index)}
                  >
                    <FaTrash size={12} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <Row className="mt-4">
        <Col md={6} className="offset-md-6">
          <div className="d-flex justify-content-between">
            <Form.Group className="me-3">
              <Form.Label>Total Debit</Form.Label>
              <CurrencyInput
                name="totalDebit"
                decimalsLimit={2}
                className="form-control"
                value={incomeAmount}
                disabled
                style={{ textAlign: "right" }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Total Credit</Form.Label>
              <CurrencyInput
                name="totalCredit"
                decimalsLimit={2}
                className="form-control"
                value={totalCredit}
                disabled
                style={{ textAlign: "right" }}
              />
            </Form.Group>
          </div>
        </Col>
      </Row>
    </Form>
  </Modal.Body>

  {/* Footer */}
  <Modal.Footer style={{ paddingLeft: "25px", paddingRight: "25px" }}>
    <Button variant="light" onClick={handleClose}>
      Cancel
    </Button>
    <Button
      onClick={postIncome}
      className={classes.btnss}
    >
      {incomeLoadingg ? (
        <>
          <Spinner size="sm" />
          <span className="ms-2">Processing...</span>
        </>
      ) : (
        "Add Remittance"
      )}
    </Button>
  </Modal.Footer>
</Modal>


      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Remitances</h3>
        <p className={classes.prgText}>Process, Add, Print, and Delete Remitances.</p>
        <Row style={{ marginTop: 16 }}>
  <Col md={3}>
    <div className={classes.thrdkad}>
      <p className={classes.kdptg}>Total Remittance Balance</p>
      <p className={classes.kdptg1}>#0.0</p>
      <div className={classes.rvnue}>
        <p className={classes.skaltxt}>Current available balance</p>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frtkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Sent</p>
        <p className={classes.kdptg2}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Total amount sent</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.fiftkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Received</p>
        <p className={classes.kdptg3}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Total amount received</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frstkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Pending Transfers</p>
        <p className={classes.kdptg4}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Transfers awaiting completion</p>
        </div>
      </div>
    </div>
  </Col>
</Row>

        <div className={classes.subContainer}>
         
          <div className={classes.threeBtns}>
                <div className={`d-flex gap-2 ${classes.awrow}`} style={{ marginTop: 10 }}>
  {/* Accounts */}
  <div style={{ minWidth: 200 }}>
    <div className="form-group">
      <label className="form-label font-weight-400">Accounts:</label>
      <Select
        onChange={(selectedOption) => handleBank(selectedOption)}
        options={allAccounts}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (provided) => ({
            ...provided,
            maxHeight: '300px',
            maxWidth: '300px',
            overflowY: 'auto',
          }),
        }}
      />
    </div>
  </div>

  {/* Start Date */}
  <div style={{ minWidth: 200 }}>
    <div className="form-group">
      <label className="form-label font-weight-400">Start Date:</label>
      <input
        className="form-control"
        type="date"
        onChange={handleDateChange}
        name="start"
        value={selectedDate}
        min={minDate}
        max={maxDate}
        required
      />
    </div>
  </div>

  {/* End Date */}
  <div style={{ minWidth: 200 }}>
    <div className="form-group">
      <label className="form-label font-weight-400">End Date:</label>
      <input
        className="form-control"
        type="date"
        onChange={handleDateChange1}
        name="end"
        value={selectedEndDate}
        min={minDate}
        max={maxDate}
        required
      />
    </div>
  </div>

</div>


          </div>
          <div className={classes.btnRight}>
            
  <OverlayTrigger
                                placement="top"
                                className={classes.btndf1}
                                overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to process remitances between the selected dates</Tooltip>}
                              >
            <button className={classes.downBtn} onClick={fetchAccounts}>
              <img src={upload} alt="upload" />{fetchingLoading ? (
    <>
        <Spinner size='sm' />
        <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
    </>
) : (
    "Process"
)}
            </button>
             </OverlayTrigger>
              <OverlayTrigger
                                    placement="top"
                                    className={classes.btndf1}
                                    overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to add remitances</Tooltip>}
onClick={() => setShow(true)}                                >
            <button className={classes.loanBtn} onClick={handleShow}>
              <img src={plus} alt="plus" /> Add Remitances
            </button>
            </OverlayTrigger>
          </div>

        </div>
         {/* <div style={{
            display: 'flex',
            gap: 16,
            alignItems: 'center',
            marginTop:10
          }}>
            <div className={classes.flexFlex}>
            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search remitance..."
              />
              {searchTerm ? (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSearchedResult([]);
                  }}
                  className={classes.clearBtn}
                >
                  ✕
                </button>
              ) : (
                <Search className={classes.searchIcon} size={16} />
              )}
            </div>
             </div>        
                           
          </div> */}
        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>S/N</th>
                <th style={{whiteSpace: "nowrap"}}>Transaction Date</th>
                <th>Particulars</th>
                <th>Descriptions</th>
                <th style={{textAlign:"right"}}>Amount</th>
                <th style={{textAlign:"center",paddingRight:30}}>Actions</th>
              </tr>
            </thead>
           <tbody>
  {benLoading ? (
    // Skeleton loading
    Array(5).fill().map((_, idx) => (
      <tr key={idx}>
        {Array(6).fill().map((_, i) => (
          <td key={i}>
            <Skeleton height={20} style={{ marginBottom: 10 }} />
          </td>
        ))}
      </tr>
    ))
  ) : isSearching ? (
    searchedResult.length === 0 ? (
      <tr>
        <td colSpan={7} style={{ textAlign: "center", color: "red" }}>
          No matching customers found
        </td>
      </tr>
    ) : (
      searchedResult.map((item, index) => (
        <tr key={index}>
          <td className={classes.textby}>{index + 1}</td>
          <td className={classes.textby}>{item.name}</td>
          <td className={classes.textby}>{item.email}</td>
          <td className={classes.textby}>{item.phone}</td>
          <td className={classes.textby}>{formatDate(item.created_at)}</td>
          <td className={classes.textby} style={{ textAlign: "right" }}>
            {parseFloat(item.balance).toLocaleString("en-US", {
              minimumIntegerDigits: 1,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </td>
          <td className={classes.btnAction} >
            <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}>
              <img src={EyeIcon} />
            </button>
            {/* <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}>
              <img src={PencilIcon} />
            </button> */}
            <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}>
              <img src={DeleteIcon} />
            </button>
          </td>
        </tr>
      ))
    )
  ) : tableData.length === 0 ? (
    // ✅ Handle empty tableData
    <tr>
      <td colSpan={7} style={{ textAlign: "center", color: "gray" }}>
        No data available
      </td>
    </tr>
  ) : (
    // Default tableData
    tableData.map((item, index) => (
      <tr key={index}>
        <td className={classes.textby}>{index + 1}</td>
        <td className={classes.textby}>{item.transaction_date || formatDate(item?.created_at)}</td>
        <td className={classes.textby}>{item.customer?.name || item?.customer}</td>
        <td style={{ whiteSpace: "wrap" }} className={classes.textby}>
          {item?.description}
        </td>
        <td style={{ textAlign: "right" }} className={classes.textby}>
          {parseFloat(item.amount).toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </td>
        <td className={classes.btnAction}>
          <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
            onClick={() => handlePrint(item?.id)}
          >
            <img src={EyeIcon} />
          </button>
          {/* <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}>
            <img src={PencilIcon} />
          </button> */}
          <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }} onClick={() => handleTrashClick(item.id)}>
            <img src={DeleteIcon} />
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>


          </table>
          {!isSearching && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}


        </div>
      </div>
      {loading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {uploading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  )
}

export default Remitance